import { DIAMETER_NOMINAL_LABELS, StrictOmit } from '@enmon/commons';
import { Descriptions } from 'antd';
import { orientationTranslated, tubeMaterialTranslated } from 'components/Form/meter_details/constants';
import { FormattedMessage, IntlShape } from 'react-intl';
import { MeterDetailWater } from '@enmon/commons/lib/enmon';
import { MeterDetails as messages } from './messages';

export type WaterDescriptionsDetails = StrictOmit<MeterDetailWater, 'flowrate'> & {
  flowrate: { value: MeterDetailWater['flowrate']; unit?: string } | null;
};

export const getWaterDetailDescriptions = (details: WaterDescriptionsDetails | undefined, intl: IntlShape) => {
  const {
    tubeMaterial,
    hotWater,
    flange,
    woltman,
    diameterNominal,
    flowrate,
    orientation,
    layLength,
    secondSerialNumber,
  } = details ?? {};

  return (
    <>
      <Descriptions.Item label={<FormattedMessage {...messages.serialNumber2} />}>
        {secondSerialNumber}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.hotWater} />}>
        {hotWater ? <FormattedMessage {...messages.yes} /> : <FormattedMessage {...messages.no} />}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.flange} />}>
        {flange ? <FormattedMessage {...messages.yes} /> : <FormattedMessage {...messages.no} />}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.woltman} />}>
        {woltman ? <FormattedMessage {...messages.yes} /> : <FormattedMessage {...messages.no} />}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.orientation} />}>
        {orientation && intl.formatMessage(orientationTranslated[orientation])}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.flowRate} values={{ unit: flowrate?.unit ?? 'Q3' }} />}>
        {flowrate?.value && `${flowrate.value} m${String.fromCharCode(179)}/h`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.layLength} />}>
        {layLength && `${layLength} mm`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.diameterDimensionNominal} />}>
        {diameterNominal && DIAMETER_NOMINAL_LABELS[diameterNominal]}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.diameterDimensionNominal} />}>
        {tubeMaterial && intl.formatMessage(tubeMaterialTranslated[tubeMaterial])}
      </Descriptions.Item>
    </>
  );
};
